import PropTypes from 'prop-types';
import { gettext } from '@eventbrite/i18n';
import noop from 'lodash/noop';
import pride_collections_touchpoint_desktop from './static/images/pride_collections_touchpoint_image.webp';
import pride_collections_touchpoint_mobile from './static/images/pride_collections_touchpoint_image_mobile.webp';
import halloween_collections_touchpoint_image from './static/images/halloween_collections_touchpoint_image.webp';
import holiday_collections_touchpoint_image from './static/images/holiday_collections_touchpoint_image.webp';
import nye_collections_touchpoint_image from './static/images/nye_collections_touchpoint_image.webp';
import valentines_collections_touchpoint_image from './static/images/valentines_collections_touchpoint_image.webp';

// NB: EB-1137596 - Changed to browse online events due to COVID19 impact
// TODO: EB-138002 - Add logic to toggle button target based on collection
export const BROWSE_EVENTS_PATH = '/d/online/all-events/';

/* Shape pulled from the formatted shape returned by the
likedEvents selector */
export const EVENT_SHAPE_PROPTYPE = PropTypes.shape({
    id: PropTypes.string,
    minPrice: PropTypes.shape({
        minPriceValue: PropTypes.number,
        currencyFormat: PropTypes.string,
        currency: PropTypes.string,
    }),
    url: PropTypes.string,
    imageUrl: PropTypes.string,
    edgeColor: PropTypes.string,
    locationInfo: PropTypes.string,
    shareOptions: PropTypes.object,
    startDate: PropTypes.string,
    startTime: PropTypes.string,
    isFree: PropTypes.bool,
    ticketsBy: PropTypes.string,
    name: PropTypes.string,
    savedByYou: PropTypes.bool,
});

export const FEATURE_FLAGS_SHAPE_PROP_TYPE = PropTypes.shape({
    facetedSearch: PropTypes.bool,
    searchMapEnhancements: PropTypes.bool,
    crazyEggFeatureFlag: PropTypes.bool,
    enableHomepageV2Subscribe: PropTypes.bool,
    enableCollections: PropTypes.bool,
});

/* Shared component configurations */
export const EDIT_COLLECTION_MODAL_CONFIG = {
    primaryText: gettext('Update'),
    primaryType: 'fill',
    secondaryText: gettext('Cancel'),
    secondaryType: 'neutral',
    onClose: noop,
};

export const UPCOMING_FILTER = 'upcoming';

/* GA TRACKING CONSTANTS */
export const EDITORIAL_COLLECTION_PAGE_GA_CATEGORY = 'editorial-collection';
export const COLLECTION_PAGE_GA_CATEGORY = 'collection';
export const REMOVE_COLLECTION_GA_ACTION = 'RemoveFromCollection';
export const EDIT_COLLECTION_GA_ACTION = 'EditCollection';
export const ADD_IMAGE_GA_ACTION = 'AddImage';
export const SAVE_COLLECTION_GA_ACTION = 'SaveCollection';
export const SHARE_COLLECTION_GA_ACTION = 'ShareCollection';
export const COPY_SHARE_LINK_GA_ACTION = 'CopyShareLink';
export const BROWSE_EVENTS_GA_ACTION = 'BrowseEvents';
export const SWITCH_TAB_GA_ACTION = 'SwitchTab';
export const SHARE_EVENT_GA_ACTION = 'ShareEvent';
export const GDPR_ACCEPT_GA_ACTION = 'FollowCollectionGDPRAccept';
export const GDPR_REJECT_GA_ACTION = 'FollowCollectionGDPRReject';
export const FOLLOW_GA_ACTION = 'FollowCollection';
export const UNFOLLOW_GA_ACTION = 'UnfollowCollection';

//Tracking for heap
export const FOLLOW_ACTION = 'FollowCollectionClick';
export const UNFOLLOW_ACTION = 'UnfollowCollectionClick';
export const FOLLOW_ACTION_SUCCESS = 'FollowCollectionSuccessful';
export const UNFOLLOW_ACTION_SUCCESS = 'UnfollowCollectionSuccessful';
export const HEAP_PAGE_AREA = 'collection';

/* GDPR MODAL */
export const GDPR_TITLE_TEXT = gettext('Get updates on this collection');
export const GDPR_MESSAGE_TEXT = gettext(
    'By clicking okay, you are agreeing to receive marketing emails and notifications about collections you follow so that you don’t miss out.',
);
export const GDPR_ACCEPT_TEXT = gettext('Okay');
export const GDPR_REJECT_TEXT = gettext('No Thanks');

export const FALLBACK_IMAGE =
    'https://cdn.evbstatic.com/s3-build/perm_001/979179/django/images/user_profile/empty_collection.png';

export const COLLECTION_TO_SLUG_MAPPING = {
    ccmxcwyc: 'ca--los-angeles',
    ccmxcwzh: 'dc--washington',
    ccmxcwyt: 'il--chicago',
    cchkwfgf: 'ny--new-york',
    cchkwfhm: 'united-kingdom--london',
    cchkwfgx: 'ca--san-francisco',
    ccmxczkc: 'ga--atlanta',
    ccmxczkt: 'tx--austin',
    ccmxczmh: 'md--baltimore',
    ccmxczmz: 'ma--boston',
    ccmxczrm: 'nc--charlotte',
    ccmxcztc: 'tx--dallas',
    ccmxcztt: 'co--denver',
    ccmxczwz: 'tx--houston',
    ccmxczwh: 'fl--miami',
    ccmxczqx: 'pa--philadelphia',
    ccmxczqf: 'wa--seattle',
    ccmxczpq: 'fl--tampa',
    ccmxczhm: 'canada--toronto',
    ccmxczgx: 'canada--vancouver',
};

export const PRIDE_COLLECTIONS_TOUCHPOINT_IMAGES = {
    imgDesktop: pride_collections_touchpoint_desktop,
    imgMobile: pride_collections_touchpoint_mobile,
};

export const HALLOWEEN_COLLECTIONS_TOUCHPOINT_IMAGES = {
    imgDesktop: halloween_collections_touchpoint_image,
    imgMobile: halloween_collections_touchpoint_image,
};

export const HOLIDAY_COLLECTIONS_TOUCHPOINT_IMAGES = {
    imgDesktop: holiday_collections_touchpoint_image,
    imgMobile: holiday_collections_touchpoint_image,
};

export const NYE_COLLECTIONS_TOUCHPOINT_IMAGES = {
    imgDesktop: nye_collections_touchpoint_image,
    imgMobile: nye_collections_touchpoint_image,
};

export const VALENTINE_COLLECTIONS_TOUCHPOINT_IMAGES = {
    imgDesktop: valentines_collections_touchpoint_image,
    imgMobile: valentines_collections_touchpoint_image,
};

/* dating touchpoint */
export const DATING_TITLE = gettext('It’s a date');
export const DATING_DESCRIPTION = gettext(
    'Meet your match. Find the perfect date plans and spark something new, no matter your relationships status.',
);
export const DATING_BASE_URL = '/b/local/home-and-lifestyle/dating/?category=';

export const DATING_BUTTONS = [
    {
        title: gettext('Speed dating'),
        category: 'speed-dating',
    },
    {
        title: gettext('LGBTQIA+'),
        category: 'lgbtqia',
    },
    {
        title: gettext('Parties'),
        category: 'parties',
    },
];

export const DATING_COLLECTION_TO_SLUG_MAPPING = {
    ccmxczxq: 'il--chicago',
    ccmxczyf: 'ca--los-angeles',
    ccmxczyx: 'dc--washington',
    ccmxczzm: 'wa--seattle',
    ccmxdbbc: 'fl--miami',
    ccmxczbm: 'ny--new-york',
};

export const HALLOWEEN_COLLECTION_TO_SLUG_MAPPING = {
    ccmxdbpx: 'ga--atlanta',
    ccmxdbrc: 'ma--boston',
    ccmxdbkz: 'il--chicago',
    ccmxdbpf: 'dc--washington',
    ccmxdbrt: 'tx--houston',
    ccmxdbmq: 'ca--los-angeles',
    ccmxdbht: 'united-kingdom--london',
    ccmxdbqm: 'fl--miami',
    ccmxdbhc: 'ny--new-york',
    ccmxdbkh: 'ca--san-francisco',
};

export const HOLIDAY_COLLECTION_TO_SLUG_MAPPING = {
    ccmxdccx: 'ma--boston',
    ccmxctxf: 'il--chicago',
    ccmxctwq: 'dc--washington',
    ccmxcttz: 'ca--los-angeles',
    ccmxctym: 'united-kingdom--london',
    ccmxdcdm: 'australia--melbourne',
    ccmxdcfc: 'fl--miami',
    ccmxctth: 'ny--new-york',
    ccmxctxx: 'ca--san-francisco',
    ccmxdcft: 'canada--toronto',
};

export const NYE_COLLECTION_TO_SLUG_MAPPING = {
    ccmxdcxt: 'ma--boston',
    cwtgcwp: 'il--chicago',
    cwtgcrb: 'dc--washington',
    cwtgcpk: 'ca--los-angeles',
    cwtppzk: 'united-kingdom--london',
    ccmxdcyh: 'australia--melbourne',
    cwtgcwb: 'fl--miami',
    cwtgckw: 'ny--new-york',
    cwtgmcb: 'ca--san-francisco',
    ccmxdcyz: 'canada--toronto',
};

export const VALENTINE_COLLECTION_TO_SLUG_MAPPING = {
    ccmxddxh: 'ma--boston',
    ccmxcwkq: 'il--chicago',
    ccmxcymc: 'dc--washington',
    ccmxcwpm: 'ca--los-angeles',
    ccmxcwmf: 'united-kingdom--london',
    ccmxddwt: 'fl--miami',
    ccmxcwhz: 'ny--new-york',
    ccmxcykm: 'ca--san-francisco',
    ccmxddwc: 'ga--atlanta',
    ccmxddtm: 'canada--toronto',
};

export const HOLIDAYS_SEASON = 'holidays';
export const NYE_SEASON = 'nye';
export const VALENTINES_SEASON = 'valentines';

export const SEASONAL_CONFIG = {
    [HOLIDAYS_SEASON]: {
        ctaText: gettext('Discover holiday events'),
        ctaLink: (collectionId) =>
            `/b/${HOLIDAY_COLLECTION_TO_SLUG_MAPPING[collectionId]}/holiday/`,
        touchpointTitle: gettext(
            'You’ve got holiday hopes… We’ve got just the thing.',
        ),
        touchpointSubtitle: (isMobile) =>
            !isMobile ? gettext('From super cozy to crazy fun.') : null,
        imageSrc: (isMobile) =>
            HOLIDAY_COLLECTIONS_TOUCHPOINT_IMAGES?.[
                isMobile ? 'imgMobile' : 'imgDesktop'
            ],
    },
    [NYE_SEASON]: {
        ctaText: gettext("Book New Year's Eve"),
        ctaLink: (collectionId) =>
            `/b/${NYE_COLLECTION_TO_SLUG_MAPPING[collectionId]}/holiday/new-years-eve/`,
        touchpointTitle: gettext(
            "A New Year's Eve to remember? We've got just the thing.",
        ),
        touchpointSubtitle: (isMobile) =>
            !isMobile
                ? gettext('From all-night ragers to earlier-bird chillers.')
                : null,
        imageSrc: (isMobile) =>
            NYE_COLLECTIONS_TOUCHPOINT_IMAGES?.[
                isMobile ? 'imgMobile' : 'imgDesktop'
            ],
    },
    [VALENTINES_SEASON]: {
        ctaText: gettext('Plan Valentine’s Day'),
        ctaLink: (collectionId) =>
            `/d/${VALENTINE_COLLECTION_TO_SLUG_MAPPING[collectionId]}/paid--events/valentine/`,
        touchpointTitle: gettext(
            'A Valentine’s Day to remember? We’ve got just the thing.',
        ),
        touchpointSubtitle: (isMobile) =>
            !isMobile
                ? gettext('From candlelight dinners to crafty DIY dates.')
                : null,
        imageSrc: (isMobile) =>
            VALENTINE_COLLECTIONS_TOUCHPOINT_IMAGES?.[
                isMobile ? 'imgMobile' : 'imgDesktop'
            ],
    },
};
